import * as React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";
import Report1Template from "./Report1Template";
import { IFormSectionPresentationModel } from "../../../../presenter/form/model/FormSectionPresentationModel";
import { IReport1Applicant } from "../../../../model/report/Report1Applicant";
import { IFormVersionItem } from "../../../../model/report/FormVersionItem";
import { IFormTypeItem } from "../../../../model/report/FormTypeItem";
import Text from "antd/lib/typography/Text";

const PDFExportReport1 = ({
  translate,
  data,
  title,
  subtitle,
  fileName,
  loader,
  applicant,
  formVersion,
  formType,
  reportingPeriodId,
  reportingPeriodFormTypeId,
  isPortal = false
}: {
  translate?: any;
  data?: IFormSectionPresentationModel[];
  title?: string;
  subtitle?: string;
  fileName: string;
  loader: any;
  applicant?: IReport1Applicant;
  formVersion?: IFormVersionItem;
  formType?: IFormTypeItem;
  reportingPeriodId?: number;
  reportingPeriodFormTypeId?: number;
  isPortal?: boolean;
}) => {
  return (
    <PDFDownloadLink
      document={
        <Report1Template
          translate={translate}
          data={data}
          title={title}
          subtitle={subtitle}
          loader={loader}
          applicant={applicant}
          formVersion={formVersion}
          formType={formType}
          reportingPeriodId={reportingPeriodId}
          reportingPeriodFormTypeId={reportingPeriodFormTypeId}
          isPortal={isPortal}
        />
      }
      fileName={fileName}
      style={{}}
    >
      {({ blob, url, loading, error }) => {
        if (error) {
          console.error("PDF Render Error", error);
          return (
            <div style={{ color: "red" }}>
              {translate("reports.document.error")}
            </div>
          );
        }
        return loading ? (
          <div style={{ marginRight: 10, marginBottom: 5 }}>
            {translate("reports.document.loading")}
          </div>
        ) : (
          <div>
            <Text className={"form-details-header-label display-sm-none"}>
              {`${translate("reports.document.download")}: `}
            </Text>
            <Icon
              type="file-pdf"
              theme={"outlined"}
              style={{
                fontSize: 20,
                color: "#ED1C24",
                marginRight: 10,
                marginBottom: 5
              }}
            />
          </div>
        );
      }}
    </PDFDownloadLink>
  );
};

export default PDFExportReport1;
